module.exports = __webpack_public_path__ + "static/media/DEI.007fccbd.png";